import tokkoChat from '@/public/images/tokko-chat.svg';

const WSP = 'whatsapp';
const EMAIL = 'email';
const TOKKO_CHAT = 'tokko_chat';

const participantMapper = {
  contact: (participant, { handleButtonClick, isButtonDisabled }) => {
    const {
      id,
      name,
      profilePicture,
      email,
      leadStatus,
      leadStatusColor,
      agentName,
      agentId,
      isValidCellphone,
    } = participant;

    const actionButtons = [];

    if (email)
      actionButtons.push({
        icon: 'icon-email',
        id: EMAIL,
        onClick: () => handleButtonClick(EMAIL, id),
        disabled: isButtonDisabled(EMAIL),
      });

    if (isValidCellphone)
      actionButtons.push({
        icon: 'icon-whatsapp',
        id: WSP,
        onClick: () => handleButtonClick(WSP, id),
        disabled: isButtonDisabled(WSP),
      });

    return {
      id,
      name,
      profilePicture,
      leadStatus,
      leadStatusColor,
      agentName,
      agentId,
      actionButtons,
    };
  },

  agent: (participant, { handleButtonClick, isButtonDisabled, ownerID }) => {
    const { id, name, profilePicture, branchName } = participant;

    const actionButtons = [];

    if (participant.id !== ownerID) {
      actionButtons.push({
        src: tokkoChat,
        icon: 'tokko-chat',
        id: TOKKO_CHAT,
        onClick: () => handleButtonClick(TOKKO_CHAT, id),
        disabled: isButtonDisabled(TOKKO_CHAT),
      });
    }

    return {
      id,
      name,
      profilePicture,
      branchName,
      actionButtons,
    };
  },
};

export default participantMapper;
